import { isNil } from '../utils';
export function validateEventsArray(events) {
    if (isNil(events) || events.length === 0) {
        events = ['child_added', 'child_removed', 'child_changed', 'child_moved'];
    }
    return events;
}
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angularfire2/database/list/utils.js
// module id = 770
// module chunks = 21